import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52983f5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReleaseEngineering" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("增值税发票")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("普通发票")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("上车价")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("到货价")
const _hoisted_7 = { class: "profile" }
const _hoisted_8 = { class: "warpper" }
const _hoisted_9 = { class: "uploads" }
const _hoisted_10 = { class: "upload" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "上传图片", -1))
const _hoisted_12 = { class: "image" }
const _hoisted_13 = { class: "upload" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "上传文档", -1))
const _hoisted_15 = { class: "document" }
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanRadio = _resolveComponent("VanRadio")!
  const _component_VanRadioGroup = _resolveComponent("VanRadioGroup")!
  const _component_VanCell = _resolveComponent("VanCell")!
  const _component_VanUploader = _resolveComponent("VanUploader")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanCalendar = _resolveComponent("VanCalendar")!
  const _component_CityPicker = _resolveComponent("CityPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanField, {
      label: "项目名称",
      placeholder: "请输入工程采购的项目名称",
      required: "",
      modelValue: $setup.submitData.title,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.submitData.title) = $event)),
      "input-align": "right",
      border: false
    }, null, 8, ["modelValue"]),
    _createVNode(_component_VanField, {
      class: "comp",
      label: "采购单位",
      placeholder: "请输入采购公司或单位名称",
      required: "",
      modelValue: $setup.submitData.company,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.submitData.company) = $event)),
      "input-align": "right",
      border: false
    }, {
      "right-icon": _withCtx(() => [
        _createElementVNode("div", {
          class: "isOpen",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.submitData.companyDisplay = !$setup.submitData.companyDisplay))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VanIcon, {
              name: `eye${$setup.submitData.companyDisplay?'':'-o'}`,
              color: $setup.submitData.companyDisplay?'#fec64b':'',
              size: "18"
            }, null, 8, ["name", "color"])
          ]),
          _createElementVNode("div", {
            class: "text",
            style: _normalizeStyle({color:$setup.submitData.companyDisplay?'#fec64b':''})
          }, "对外" + _toDisplayString($setup.submitData.companyDisplay?'显示':'隐藏'), 5)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_VanField, {
      label: "截止日期",
      placeholder: "请选择截止日期",
      required: "",
      readonly: "",
      modelValue: $setup.submitData.expires,
      "input-align": "right",
      "is-link": "",
      border: false,
      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isShowTimePicker = true))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_VanField, {
      label: "收货地区",
      placeholder: "请选择收货地区",
      required: "",
      readonly: "",
      modelValue: $setup.submitData.receiptAddress,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.submitData.receiptAddress) = $event)),
      "input-align": "right",
      "is-link": "",
      border: false,
      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.isShowCityPicker = true))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_VanField, {
      label: "发票类型",
      placeholder: "请输入采购公司或单位名称",
      modelValue: $setup.submitData.projectName,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.submitData.projectName) = $event)),
      "input-align": "right",
      border: false
    }, {
      input: _withCtx(() => [
        _createVNode(_component_VanRadioGroup, {
          modelValue: $setup.submitData.invoiceType,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.submitData.invoiceType) = $event)),
          direction: "horizontal",
          "checked-color": "#fec64b"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VanRadio, {
              name: "1",
              shape: "square"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_VanRadio, {
              name: "2",
              shape: "square"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_VanField, {
      label: "报价方式",
      placeholder: "请输入采购公司或单位名称",
      modelValue: $setup.submitData.projectName,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.submitData.projectName) = $event)),
      "input-align": "right",
      border: false
    }, {
      input: _withCtx(() => [
        _createVNode(_component_VanRadioGroup, {
          modelValue: $setup.submitData.payTerm,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.submitData.payTerm) = $event)),
          direction: "horizontal",
          "checked-color": "#fec64b"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VanRadio, {
              name: "1",
              shape: "square"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_VanRadio, {
              name: "2",
              shape: "square"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_VanCell, {
        title: "采购说明",
        border: false
      }),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_VanField, {
          class: "textarea",
          modelValue: $setup.submitData.profile,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.submitData.profile) = $event)),
          rows: "5",
          autosize: "",
          type: "textarea",
          maxlength: "100",
          placeholder: "请填写详细说明",
          "show-word-limit": ""
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createVNode(_component_VanUploader, {
            accept: "image/*",
            "max-count": 1,
            "after-read": $setup.imageAfterRead
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_VanIcon, {
                  name: "photo",
                  size: "24",
                  color: "#999"
                }),
                _hoisted_11
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, !$setup.uploadImage]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createVNode(_component_VanImage, {
              src: $setup.uploadImage,
              width: "72px",
              height: "72px"
            }, null, 8, ["src"]),
            _createVNode(_component_VanIcon, {
              class: "close",
              name: "clear",
              size: "16",
              color: "#999",
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.uploadImage = ""))
            })
          ], 512), [
            [_vShow, $setup.uploadImage]
          ]),
          _withDirectives(_createVNode(_component_VanUploader, {
            accept: "application/vnd.ms-excel,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "max-count": 1,
            "after-read": $setup.documentAfterRead
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_VanIcon, {
                  name: "printer",
                  size: "24",
                  color: "#999"
                }),
                _hoisted_14
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, !$setup.submitData.documentUrl]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createVNode(_component_VanIcon, {
              name: "printer",
              size: "24",
              color: "#999"
            }),
            _createElementVNode("div", _hoisted_16, _toDisplayString($setup.documentName), 1),
            _createVNode(_component_VanIcon, {
              class: "close",
              name: "clear",
              size: "16",
              color: "#999",
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.submitData.documentUrl = ""))
            })
          ], 512), [
            [_vShow, $setup.submitData.documentUrl]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_VanButton, {
        type: "primary",
        block: "",
        onClick: $setup.submit,
        color: "#fec64b"
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_VanCalendar, {
      show: $setup.isShowTimePicker,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => (($setup.isShowTimePicker) = $event)),
      onConfirm: $setup.onConfirm,
      color: "#fec64b",
      "min-date": new Date()
    }, null, 8, ["show", "min-date"]),
    _createVNode(_component_CityPicker, {
      modelValue: $setup.isShowCityPicker,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.isShowCityPicker) = $event)),
      onConfirm: $setup.cityConfirm
    }, null, 8, ["modelValue"])
  ]))
}